import { css } from '@emotion/react';

const MUTED_TEXT = '#4f4f4f';
const BORDER = '#ededed';

const makeSolarMapPinStyles = ({ theme } = {}) => {
  const green =
    theme?.mvf?.palette?.component?.continueButtonColor ?? '#03624c';
  const greenHover =
    theme?.mvf?.palette?.component?.continueButtonHoverColor ?? green;

  return {
    modal: css({
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '90%',
      maxWidth: 600,
      maxHeight: '90vh',
      overflowY: 'auto',
      backgroundColor: '#ffffff',
      borderRadius: 16,
      padding: 24,
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    }),
    header: css({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 12,
    }),
    title: css({
      fontSize: '1.25rem',
      fontWeight: 700,
      color: '#000000',
      margin: 0,
    }),
    closeButton: css({
      background: 'none',
      border: 'none',
      padding: 0,
      fontSize: '1.75rem',
      lineHeight: 1,
      color: MUTED_TEXT,
      cursor: 'pointer',
      width: 36,
      height: 36,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      transition: 'background-color 0.2s',
      '&:hover': { backgroundColor: 'rgba(237, 237, 237, 0.5)' },
    }),
    instructions: css({
      fontSize: '0.875rem',
      color: MUTED_TEXT,
      lineHeight: 1.5,
      margin: '0 0 16px',
    }),
    currentAddress: css({
      backgroundColor: 'rgba(237, 237, 237, 0.5)',
      border: `1px solid ${BORDER}`,
      borderRadius: 8,
      padding: '12px 16px',
      marginBottom: 16,
    }),
    addressLabel: css({
      display: 'block',
      fontSize: '0.75rem',
      color: MUTED_TEXT,
      marginBottom: 4,
    }),
    addressValue: css({
      fontSize: '0.875rem',
      color: '#000000',
      fontWeight: 500,
    }),
    mapContainer: css({
      height: 350,
      borderRadius: 12,
      overflow: 'hidden',
      marginBottom: 16,
      backgroundColor: 'rgba(237, 237, 237, 0.5)',
      '@media (max-width: 480px)': { height: 280 },
    }),
    unavailable: css({
      height: 350,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: 16,
      color: MUTED_TEXT,
      '@media (max-width: 480px)': { height: 280 },
    }),
    coordinates: css({
      backgroundColor: 'rgba(237, 237, 237, 0.3)',
      borderRadius: 8,
      padding: '12px 16px',
      marginBottom: 16,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }),
    coordLabel: css({ fontSize: '0.75rem', color: MUTED_TEXT }),
    coordValue: css({
      fontFamily: 'monospace',
      fontSize: '0.875rem',
      color: '#000000',
      fontWeight: 500,
    }),
    actions: css({
      display: 'flex',
      gap: 16,
      '@media (max-width: 480px)': { flexDirection: 'column' },
    }),
    cancelButton: css({
      flex: 1,
      padding: '14px 24px',
      backgroundColor: 'transparent',
      color: MUTED_TEXT,
      border: `1px solid ${BORDER}`,
      borderRadius: 8,
      fontSize: '0.875rem',
      fontWeight: 600,
      cursor: 'pointer',
      transition: 'all 0.2s',
      '&:hover': {
        backgroundColor: 'rgba(237, 237, 237, 0.5)',
        borderColor: '#c8c8c8',
      },
    }),
    confirmButton: css({
      flex: 1,
      padding: '14px 24px',
      backgroundColor: green,
      color: '#ffffff',
      border: 'none',
      borderRadius: 8,
      fontSize: '0.875rem',
      fontWeight: 600,
      cursor: 'pointer',
      transition: 'background-color 0.2s',
      '&:hover:not(:disabled)': { backgroundColor: greenHover },
      '&:disabled': {
        backgroundColor: BORDER,
        color: MUTED_TEXT,
        cursor: 'not-allowed',
      },
    }),
  };
};

export default makeSolarMapPinStyles;
